const Blockly = require('blockly');
const { config } = require('@sstdev/lib_metadata-config');
const BaseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const setupAddCodeProperties = require('../../helpers/addCodeProperties');
const convertToBoolean = require('../../helpers/convertToBoolean');

class RangeType extends BaseMdcBlockGroup {
    /**
     * @param {{[key: string]: any}} code
     * @param {import('blockly').Block} blocklyBlock
     * @param {string} hNodeType
     */
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

        if (hNodeType === 'DateTime') {
            addCodeProperties(['format']);
            addCodeProperties([{ key: 'showAsModal', handler: convertToBoolean }]);
        }

        return JSON.stringify(code);
    }

    /**
     * @param {*} color
     * @param {import('blockly').Block} blocklyBlock
     * @param {string} hNodeType
     */
     
    addToBlocksCustom(color, blocklyBlock, hNodeType) {
        if (hNodeType === 'DateTime') {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Format:')
                .appendField(new Blockly.FieldDropdown(config.dateTimeFormatOptions), 'format')
                .appendField('  Show as modal:')
                .appendField(new Blockly.FieldCheckbox(), 'showAsModal');
        }
        if (['Integer'].includes(hNodeType)) {
            blocklyBlock.setEnabled(false);
        }
    }
}

module.exports = RangeType;
